<template>
  <div class="pageBar">
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <div class="crumbs-controls">
      <slot name="controls"></slot>
      <slot name="refresh">
        <el-button type="primary" @click="handleRefresh">
          <i ref="refresh" :class="{'el-icon-refresh':true,'refreshAnima':isRefresh}"></i>
        </el-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pageBar',
  props:{
    title:{
      default:"",
      type:String
    }
  },
  data() {
    return {
      isRefresh:false,
      timer:null
    }
  },
  components: {

  },
  methods:{
    goBack(){
      this.$emit('back');
    },
    /**点击刷新 */
    handleRefresh(){
      //添加防抖
      this.isRefresh = true;
      if(this.timer){
        window.clearTimeout(this.timer);
      } else {
        // window.console.log("执行刷新");
        this.$emit('refresh');
      }
      this.timer = window.setTimeout(()=>{
        // window.console.log("执行setTimeOut")
        this.isRefresh = false;
        window.clearTimeout(this.timer);
        this.timer = null;
      },1000)
    }
  },
  
}
</script>

<style scoped>
.pageBar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 0.5px solid #dcdcdc;
}
.refreshAnima{
  transition: transform 1s;
  transform: rotate(360deg);
}
.crumbs-controls{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 80%;
}
</style>